import React from "react";
import Button from "../button/button";

const ModalTooLongContentTitle = props => {
	return (
		<div className="modal-too-long-content-title">
			{props.title}
			<Button className="btn-gray-md-icon" onClick={props.close}>
				<i className="icon-close" />
			</Button>
		</div>
	);
};

export default ModalTooLongContentTitle;
